import { generateRandomString } from '@mntn-dev/utilities'
import type { ZodSimplify } from '@mntn-dev/utility-types'
import { z } from 'zod'

export const MntnCreditProgramIdSchema = z
  .string()
  .min(1)
  .max(128)
  .brand<'mntn-credit-program-id'>()

export type MntnCreditProgramId = ZodSimplify<typeof MntnCreditProgramIdSchema>

export const MntnCreditProgramId = (value: string = generateRandomString()) => {
  return MntnCreditProgramIdSchema.parse(value)
}
